import { render, staticRenderFns } from "./ClaimNotificationsButton.vue?vue&type=template&id=04892818&scoped=true&"
import script from "./ClaimNotificationsButton.vue?vue&type=script&lang=js&"
export * from "./ClaimNotificationsButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04892818",
  null
  
)

export default component.exports